// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"23dcd4ca","442":"00db279c","801":"23dcd4ca"}[chunkId] + ".chunk.css";
};